export default "__VITE_ASSET__4311a5ee__"